import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface IFilterStoreProps {
  providerIds: string[];
  partnerId: string;
  setProviderIds: (ids: string[]) => void;
  setPartnerId: (id: string) => void;
  clearProviderIds: () => void;
  clearStore: () => void;
}

export const useAllWorklistStore = create<IFilterStoreProps>()(
  persist(
    set => ({
      providerIds: [],
      partnerId: '',
      setProviderIds: ids => set({ providerIds: ids }),
      setPartnerId: id => set({ partnerId: id }),
      clearProviderIds: () => set({ providerIds: [] }),
      clearStore: () => set({ providerIds: [], partnerId: '' }),
    }),
    {
      name: 'all-worklist-store',
    },
  ),
);
